import { PropType, h, defineComponent } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '@frontend/state';
import BarButton from '@components/bar-button';
import {
    make_moving_coordinates_invisible,
    make_moving_coordinates_visible,
    moving_coordinates_visible,
} from '../../../state';
import coordinates_svg from '../../../../../../frontend/phi3d/src/assets/img/SVG_icons/Bottom/visualisation/show_coordinates_moving.svg';
import { img } from '@phi/components';
import { ShowMovingCoordinatesTooltip } from '../../tooltips/show-moving-coordinates-tooltip';

export const MovingCoordinatesIcon = coordinates_svg;

export const ShowMovingCoordinates = defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Show moving object coordinates';
        },

        disabled() {
            return !this.state.loaded;
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return false;
            else if (moving_coordinates_visible.value)
                make_moving_coordinates_invisible();
            else
                make_moving_coordinates_visible();
        },
    },

    render() {
        return h(BarButton, {
            id: 'toggle-coordinates-moving-button',
            tippy: 'right',
            disabled: this.disabled,
            active: moving_coordinates_visible.value,
            selected: this.state.tut_stage === 3,
            onClick: this.onClick,
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(coordinates_svg, this.alt),
            tooltip: ShowMovingCoordinatesTooltip,
        });
    },
});
